export default __webpack_public_path__ + "static/media/ion_location-sharp.2e650960.svg";